<template>
  <v-autocomplete
    v-bind="$attrs"
    v-on="$listeners"
    :items="items"
    filled
    dense
  ></v-autocomplete>
</template>

<script>

  export default {
    name: 'LocationStatus',
    data: () => ({
      items: [
        {
          text: 'Constructed',
          value: 'constructed',
        },
        {
          text: 'Unlocked',
          value: 'Unlocked',
        },
        {
          text: 'Planned',
          value: 'Planned',
        },
        {
          text: 'Terminated',
          value: 'TERMINATED',
        },
        {
          text: 'Ongoing',
          value: 'ONGOING',
        },
        {
          text: 'Canceled',
          value: 'CANCELLED',
        },
      ],
    }),
  }
</script>

<style scoped>

</style>
